<template>
  <v-container class="fill-height d-flex justify-center align-center">
    <v-sheet
      class="border-opacity-25 overflow-hidden border-thin rounded-lg pa-5"
      max-width="600"
      width="100%">
      <v-form>
        <v-file-input v-model="file" label="Choose a file" :accept="fileType"></v-file-input>
        <v-row>
          <v-col>
            <v-btn
              color="secondary"
              block
              class="rounded-lg mb-8"
              elevation="2"
              @click="handleCancel"
              >Cancel</v-btn
            >
          </v-col>
          <v-col>
            <v-btn
              :disabled="!file"
              color="primary"
              block
              class="rounded-lg mb-8"
              elevation="2"
              @click="uploadAsset"
              >Upload</v-btn
            >
          </v-col>
        </v-row>
        <v-progress-linear
          v-if="uploadProgress > 0"
          v-model="uploadProgress"
          height="10"
          color="blue"></v-progress-linear>
      </v-form>
    </v-sheet>
  </v-container>
</template>
<script setup lang="ts">
import { createProgressHandler } from '@/controllers';
import { IAssetDTO } from '@/dtos';

import { computed, ref } from 'vue';
const emit = defineEmits(['uploadCanceled', 'uploadCompleted', 'snack']);
interface Props {
  type: ('image' | 'video' | 'pdf' | 'any')[];
  onUpload: (file: File, updateProgress: (progress: number) => void) => Promise<IAssetDTO>;
}
const props = defineProps<Props>();

const fileType = computed(() => {
  const types = Array.isArray(props.type) ? props.type : [props.type];

  const mapped = types.map((t) => {
    if (t === 'image') return 'image/*';
    if (t === 'video') return 'video/*';
    if (t === 'pdf') return 'application/pdf';
    return '*';
  });

  return mapped.join(',');
});

const file = ref<File>();
const uploadProgress = ref<number>(0);
const uploadCompleted = ref<boolean>(false);
const isAdding = ref<boolean>(false);

const handleCancel = () => {
  if (isAdding.value == true) {
    isAdding.value = false;
  } else {
    emit('uploadCanceled');
  }
};

const uploadAsset = async () => {
  if (!file.value) {
    emit('snack', 'File', 'error', 'No file selected');
    return;
  }

  try {
    const progress = createProgressHandler(uploadProgress, uploadCompleted);
    await props.onUpload(file.value, progress);
    emit('uploadCompleted');
  } catch (error: unknown) {
    const msg = error as string;
    emit('snack', 'File', 'error', `Upload failed: ${msg}`);
  }
};
</script>
